<template>
  <div>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: center;">
      <div style="width: 200px;">
        <el-input v-model="newQrChannel" placeholder="分组"></el-input>
        <el-input v-model="newQrName" placeholder="名称"></el-input>
      </div>
      <el-upload
          style="margin-left: 16px;"
          list-type="picture-card"
          :multiple="false"
          :limit="1"
          :on-success="onUploadSuccess"
          :on-remove="onRemovePic"
          action="https://devmolv.com/CwHelper/uploadGroupQrCode">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-button
          style="margin-left: 16px;"
          type="primary"
          @click="newQr">
        新增二维码
      </el-button>
    </div>
    <div v-for="(item, index) in allQr" :key="index" style="margin-top: 16px; border: 1px solid #888888;"
         v-loading="qrLoading">
      <div style="background: #988329; font-size: 18px; line-height: 2em; padding-left: 16px;">{{ item.channel }}</div>
      <div
          style="width: 100%; height: auto; padding-top: 8px; padding-bottom: 8px; display: flex; flex-direction: row; justify-content: start; align-items: center; overflow-x: auto;">
        <div v-for="(qr, index2) in item.children" :key="index2" style="margin-left: 32px;">
          <img :src="qr.url" style="width: 150px; box-shadow: 0 0 5px #888888;">
          <div style="font-size: 14px;">{{ qr.name }}</div>
          <el-button
              type="primary"
              icon="el-icon-s-promotion"
              @click="deleteQr(item.channel, qr.name)"
              size="mini">
            删除
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WxGroup",
  data() {
    return {
      allQr: [],
      newQrChannel: null,
      newQrName: null,
      newQrUrl: null,
      qrLoading: false,
    }
  },
  mounted() {
    this.getAllQr();
  },
  methods: {
    //获取全部二维码
    getAllQr() {
      let that = this;
      this.$api
          .post('https://devmolv.com/CwHelper/getAllGroupQr', {})
          .then(response => {
            if (response.data.resultCode === 0) {
              that.allQr = response.data.allQrList;
            }
          });
    },
    //新增二维码
    newQr() {
      let that = this;
      if (!that.newQrChannel) {
        that.$message({
          message: '请输入分组',
          type: 'success',
          duration: 1000,
          showClose: true
        });
        return;
      }
      if (!that.newQrName) {
        that.$message({
          message: '请输入名称',
          type: 'success',
          duration: 1000,
          showClose: true
        });
        return;
      }
      if (!that.newQrUrl) {
        that.$message({
          message: '请上传二维码',
          type: 'success',
          duration: 1000,
          showClose: true
        });
        return;
      }
      that.qrLoading = true;
      this.$api
          .post('https://devmolv.com/CwHelper/addGroupQr', {
            'channel': that.newQrChannel,
            'name': that.newQrName,
            'url': that.newQrUrl,
          })
          .then(response => {
            if (response.data.resultCode === 0) {
              that.getAllQr();
            }
          }).finally(() => {
        that.qrLoading = false;
      });
    },
    onUploadSuccess(response, file, fileList) {
      this.newQrUrl = response.fileUrl;
    },
    onRemovePic(file, fileList) {
      this.newQrUrl = null;
    },
    //删除二维码
    deleteQr(channel, name) {
      let that = this;
      this.qrLoading = true;
      this.$api
          .post('https://devmolv.com/CwHelper/deleteGroupQr', {
            'channel': channel,
            'name': name,
          })
          .then(response => {
            if (response.data.resultCode === 0) {
              that.getAllQr();
            }
          }).finally(() => {
        that.qrLoading = false;
      });
    }
  }
};
</script>

<style>

</style>